import { IFormInput } from '../ContactUsForm';

export function setErrorOn400(
  setError: any
  // eslint-disable-next-line unused-imports/no-unused-vars
): ((value: Response) => any) | null | undefined {
  return (response) => {
    if (response.ok) {
      return response.json();
    }
    if (response.status === 400) {
      response.json().then((data) => {
        Object.keys(data).map((key, index) => {
          setError(
            key as keyof IFormInput,
            {
              type: 'manual',
              message: data[key][0],
            },
            { shouldFocus: index == 0 }
          );
        });
      });
    }
    throw new Error('Network response was not ok.');
  };
}
